/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CandidateOfferFiltersModalityList
 */
export interface CandidateOfferFiltersModalityList {
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferFiltersModalityList
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateOfferFiltersModalityList
     */
    value?: number;
}

export function CandidateOfferFiltersModalityListFromJSON(json: any): CandidateOfferFiltersModalityList {
    return CandidateOfferFiltersModalityListFromJSONTyped(json, false);
}

export function CandidateOfferFiltersModalityListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateOfferFiltersModalityList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CandidateOfferFiltersModalityListToJSON(value?: CandidateOfferFiltersModalityList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'value': value.value,
    };
}


